package com.nikolastojiljkovic.dotty.compiler.shared

import io.circe.Codec

case class CompilationParams(uri: String, diagnostics: List[CompilationDiagnostic]) derives Codec.AsObject

